export const response = {
	message: 'Ok',
	status_code: 200,
	success: true,
	data: [
		{
			type: 'variant',
			parent_id: '4764f368-f840-4fc0-a6db-d58c533e093e',
			custom_attributes: [
				{
					id: 'f8da3c80-d78a-442f-bd7c-df0b25434ee3',
					name: 'other_information',
					type: 'textarea',
					value:
						'WASHING: Wash separately in cold water on a short, gentle cycle, with as much water as possible to allow for movement.\nDRYING: Careful drying is really important. Tumble dry on a delicate setting, low heat. ',
				},
				{
					id: 'eb3b0caf-4be1-4573-933b-d681317c8cff',
					name: 'description',
					type: 'textarea',
					value:
						'Soon to become your favorite year-round staple. Our blankets is designed with cuddling in mind and all-Cotton construction gives it a comfy and light feel. Expertly crafted for everyday use, the blanket has an ideal weight that works in every climate. Our Cotton textural woven blanket has a solid border which gives a nice tailoRed look for those who sleep warm year round regardless of climate.nnAvailable in White & Ivory to perfectly match your style.',
				},
				{
					id: '4c449ea4-c805-4c8a-88fc-c35ae9dbca66',
					name: 'weight',
					type: 'text',
					value: '1.5 lbs',
				},
				{
					id: 'c4e61f4f-d1f6-4204-9a71-bd11fde99780',
					name: 'dimensions',
					type: 'text',
					value: '110X96 Inch',
				},
				{
					id: 'c065b336-6917-4897-823d-f62e430846de',
					name: 'color',
					type: 'select',
					value: 'Off-white',
				},
				{
					id: 'fdf8ff72-6f1f-4654-8714-6466cb1e8424',
					name: 'size',
					type: 'select',
					value: 'Queen',
				},
			],
			moq: 5,
			status: 'published',
			updated_at: '2023-07-26T16:01:00.245327',
			media: [
				{
					id: '1',
					url: 'https://orchidsluxhome.com/wp-content/uploads/2022/05/HUDSON-BLANKET-OFF-WHITE-1-1.jpg',
					type: 'image',
					is_primary: true,
				},
				{
					id: '2',
					url: 'https://orchidsluxhome.com/wp-content/uploads/2022/05/HUDSON-BLANKET-OFF-WHITE-2-1.jpg',
					type: 'image',
					is_primary: false,
				},
			],
			id: 'a164f581-44ce-4e30-9c97-1ccc517b046a',
			name: 'Hudson Blanket',
			variants_meta: {
				hinges_value_map: {
					'c065b336-6917-4897-823d-f62e430846de': [
						{
							value: 'White',
							priority: 0,
							type: 'image_label',
							type_value: 'https://sourcerer.tech/assets/47bcc37d-736a-4e2b-835e-a787b08e9f43',
						},
						{
							value: 'Off-white',
							priority: 0,
							type: 'image_label',
							type_value: 'https://orchidsluxhome.com/wp-content/uploads/2022/05/HUDSON-BLANKET-OFF-WHITE-1-1.jpg',
						},
					],
					'fdf8ff72-6f1f-4654-8714-6466cb1e8424': [
						{
							value: 'King',
							priority: 0,
							type: 'chip',
							type_value: '',
						},
						{
							value: 'Queen',
							priority: 0,
							type: 'chip',
							type_value: '',
						},
					],
				},
				variant_data_map: [
					{
						'c065b336-6917-4897-823d-f62e430846de': 'White',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'King',
						product_id: '4764f368-f840-4fc0-a6db-d58c533e093e',
					},
					{
						'c065b336-6917-4897-823d-f62e430846de': 'Off-white',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'King',
						product_id: '2310a1c0-00de-4988-a06f-0797316a4801',
					},
					{
						'c065b336-6917-4897-823d-f62e430846de': 'White',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'Queen',
						product_id: '19ad5242-e7e2-422e-b5c8-78a3526f72ff',
					},
					{
						'c065b336-6917-4897-823d-f62e430846de': 'Off-white',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'Queen',
						product_id: 'a164f581-44ce-4e30-9c97-1ccc517b046a',
					},
				],
				hinge_attributes: [
					{
						id: 'c065b336-6917-4897-823d-f62e430846de',
						name: 'color',
						priority: 0,
					},
					{
						id: 'fdf8ff72-6f1f-4654-8714-6466cb1e8424',
						name: 'size',
						priority: 0,
					},
				],
			},
			tenant_id: '49874fec-b7a0-4745-8bc6-43409b85a6cf',
			created_at: '2023-07-26T14:56:28.011427',
			sku_id: 'BL-852-11099',
			pricing: {
				variant_price_range: {
					min_value: 270,
					max_value: 330,
				},
				unit: 'per piece',
				id: '0008985b-477d-4527-a5d9-4d5a720b1a74',
				pricing_rule: {
					volume: {
						name: 'Volume Discount',
						type: 'Volume',
						tiers: [],
					},
				},
				price: 270,
				product_id: 'a164f581-44ce-4e30-9c97-1ccc517b046a',
				price_level_id: '01d11338-4674-4643-a013-f18c5e579d98',
				currency: '$',
			},
			inventory: {
				min_order_quantity: 5,
				incremental_value: 5,
				max_order_quantity: 100,
				stock: 200,
				name: 'In Stock : 200.0 pcs',
				box_color: 'primary',
				show_stock_list: 'true',
				list: {
					in_stock: '200.0 pcs',
					on_hold: '',
					on_loom: '',
				},
			},
			category: [
				{
					name: 'Blanket',
					children: null,
					level: 2,
					id: 'ce0626d0-8ae4-4a17-bdcc-e55e1373efea',
					parent_id: '41b81e51-f4ba-4318-9c89-bafb5f0c9e89',
					path: '41b81e51-f4ba-4318-9c89-bafb5f0c9e89,41b81e51-f4ba-4318-9c89-bafb5f0c9e89',
				},
			],
			collections: [
				{
					id: '1b40223f-0813-4afb-ba6c-6b370426f365',
					media: [
						{
							type: 'image',
							view_type: 'thumbnail',
							url: ' https://orchidsluxhome.com/wp-content/uploads/2022/04/celestialribknitthrowslate2-1.jpg',
						},
					],
					name: 'New arrivals',
					priority: 0,
				},
			],
		},
		{
			type: 'variant',
			parent_id: 'd8d9ee46-9990-4f62-bbec-149b2883eba5',
			custom_attributes: [
				{
					id: 'f8da3c80-d78a-442f-bd7c-df0b25434ee3',
					name: 'other_information',
					type: 'textarea',
					value:
						'Care Instruction\\n- Machine wash cold with like Colors, Gentle cycle, do not bleach, Tumble - Dry low, Remove promptly, Warm iron as needed. Dry Clean if needed',
				},
				{
					id: 'eb3b0caf-4be1-4573-933b-d681317c8cff',
					name: 'description',
					type: 'textarea',
					value:
						"The stripe towel collection is inspiRed by the beauty of coasts around the world. This towel is a great decorative accent, and perfect for travel and bath use. The pure woven Cotton is both soft and absorbent. The collection's Colors are reminiscent of a ocean voyage on a calm day.",
				},
				{
					id: '4c449ea4-c805-4c8a-88fc-c35ae9dbca66',
					name: 'weight',
					type: 'text',
					value: '0.67 lbs',
				},
				{
					id: 'c4e61f4f-d1f6-4204-9a71-bd11fde99780',
					name: 'dimensions',
					type: 'text',
					value: '35.0x70.0inch',
				},
				{
					id: 'c065b336-6917-4897-823d-f62e430846de',
					name: 'color',
					type: 'select',
					value: 'Yellow',
				},
				{
					id: 'fdf8ff72-6f1f-4654-8714-6466cb1e8424',
					name: 'size',
					type: 'select',
					value: 'Bath Sheet',
				},
			],
			moq: 1,
			status: 'published',
			updated_at: '2023-07-26T15:45:51.579874',
			media: [
				{
					id: '1',
					url: 'https://orchidsluxhome.com/wp-content/uploads/2022/04/stripesbathsheetgreyyellow1-1.jpg',
					type: 'image',
					is_primary: true,
				},
			],
			id: 'afc99698-849d-4547-ba6a-0b868e5517f5',
			name: 'Striped Bath Sheet',
			variants_meta: {
				hinges_value_map: {
					'c065b336-6917-4897-823d-f62e430846de': [
						{
							value: 'Yellow',
							priority: 0,
							type: 'image_label',
							type_value: 'https://orchidsluxhome.com/wp-content/uploads/2022/04/stripesbathsheetgreyyellow1-1.jpg',
						},
						{
							value: 'Red',
							priority: 0,
							type: 'image_label',
							type_value: 'https://orchidsluxhome.com/wp-content/uploads/2022/04/stripesbathsheetredblue1-1.jpg',
						},
						{
							value: 'Aqua',
							priority: 0,
							type: 'image_label',
							type_value: 'https://orchidsluxhome.com/wp-content/uploads/2022/04/stripesbathsheetaquaindigo1-1.jpg',
						},
					],
					'fdf8ff72-6f1f-4654-8714-6466cb1e8424': [
						{
							value: 'Bath Sheet',
							priority: 0,
							type: 'chip',
							type_value: '',
						},
					],
				},
				variant_data_map: [
					{
						'c065b336-6917-4897-823d-f62e430846de': 'Yellow',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'Bath Sheet',
						product_id: 'afc99698-849d-4547-ba6a-0b868e5517f5',
					},
					{
						'c065b336-6917-4897-823d-f62e430846de': 'Red',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'Bath Sheet',
						product_id: '2b3fb784-02ce-4ebc-85b5-1426745e9563',
					},
					{
						'c065b336-6917-4897-823d-f62e430846de': 'Aqua',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'Bath Sheet',
						product_id: '3cf6c395-04e7-4db1-a298-4f1aea564dd5',
					},
				],
				hinge_attributes: [
					{
						id: 'c065b336-6917-4897-823d-f62e430846de',
						name: 'color',
						priority: 0,
					},
					{
						id: 'fdf8ff72-6f1f-4654-8714-6466cb1e8424',
						name: 'size',
						priority: 0,
					},
				],
			},
			tenant_id: '49874fec-b7a0-4745-8bc6-43409b85a6cf',
			created_at: '2023-07-26T14:56:28.011427',
			sku_id: 'BS-3001A-3570',
			pricing: {
				variant_price_range: {
					min_value: 60,
					max_value: 60,
				},
				unit: 'per piece',
				id: '951247c5-c883-4d72-88cd-e0ea0459c76c',
				pricing_rule: {
					volume: {
						name: 'Volume Discount',
						type: 'Volume',
						tiers: [],
					},
				},
				price: 60,
				product_id: 'afc99698-849d-4547-ba6a-0b868e5517f5',
				price_level_id: '01d11338-4674-4643-a013-f18c5e579d98',
				currency: '$',
			},
			inventory: {
				min_order_quantity: 1,
				incremental_value: 1,
				max_order_quantity: 10000,
				stock: 66,
				name: 'In Stock : 66.0 pcs',
				box_color: 'primary',
				show_stock_list: 'true',
				list: {
					in_stock: '66.0 pcs',
					on_hold: '',
					on_loom: '',
				},
			},
			category: [
				{
					name: 'Towel',
					children: null,
					level: 2,
					id: 'e1590426-09c5-4ed1-ba38-659429046bcf',
					parent_id: '38f8e7b9-a53f-4dab-a78f-256cb5fd5fe6',
					path: '38f8e7b9-a53f-4dab-a78f-256cb5fd5fe6,38f8e7b9-a53f-4dab-a78f-256cb5fd5fe6',
				},
			],
			collections: null,
		},
		{
			type: 'variant',
			parent_id: 'ddc5dc59-b68a-4c57-93b2-6fbc6530dfad',
			custom_attributes: [
				{
					id: 'f8da3c80-d78a-442f-bd7c-df0b25434ee3',
					name: 'other_information',
					type: 'textarea',
					value:
						'Use a Large Capacity Washer & Dryer, Machine Wash In Cold Water Separately, Gentle Cycle, Do Not Bleach, Tumble Dry Low, Remove Promptly, Warm Iron',
				},
				{
					id: 'eb3b0caf-4be1-4573-933b-d681317c8cff',
					name: 'description',
					type: 'textarea',
					value:
						'Dress Your Bed In Our Signature Diamond Quilted Velentina Coverlet And Shams For Luxury And Comfort. This Collection Has Been Created With A Perfect Weight For Layering And Is A Classic Staple And Pairs Perfectly With Various Patterns And Prints. This Collection Is Made From 100% Cotton Sateen 300 Thread Count.',
				},
				{
					id: '4c449ea4-c805-4c8a-88fc-c35ae9dbca66',
					name: 'weight',
					type: 'text',
					value: '8.5 lbs',
				},
				{
					id: 'c4e61f4f-d1f6-4204-9a71-bd11fde99780',
					name: 'dimensions',
					type: 'text',
					value: '94X96 Inch',
				},
				{
					id: 'c065b336-6917-4897-823d-f62e430846de',
					name: 'color',
					type: 'select',
					value: 'Mint',
				},
				{
					id: 'fdf8ff72-6f1f-4654-8714-6466cb1e8424',
					name: 'size',
					type: 'select',
					value: 'King',
				},
			],
			moq: 5,
			status: 'published',
			updated_at: '2023-07-26T15:45:51.579874',
			media: [
				{
					id: '1',
					url: 'https://orchidsluxhome.com/wp-content/uploads/2023/01/CL-252-9496_1.jpg',
					type: 'image',
					is_primary: true,
				},
				{
					id: '2',
					url: 'https://orchidsluxhome.com/wp-content/uploads/2023/01/CL-252-9496_2.jpg',
					type: 'image',
					is_primary: false,
				},
			],
			id: '54f08aea-778b-46ff-8920-d83c996a69bc',
			name: 'Velentina Coverlet',
			variants_meta: {
				hinges_value_map: {
					'c065b336-6917-4897-823d-f62e430846de': [
						{
							value: 'Mint',
							priority: 0,
							type: 'image_label',
							type_value: 'https://orchidsluxhome.com/wp-content/uploads/2023/01/CL-252-9496_1.jpg',
						},
						{
							value: 'Blue',
							priority: 0,
							type: 'image_label',
							type_value: 'https://orchidsluxhome.com/wp-content/uploads/2023/01/CL-251-9496_1.jpg',
						},
					],
					'fdf8ff72-6f1f-4654-8714-6466cb1e8424': [
						{
							value: 'King',
							priority: 0,
							type: 'chip',
							type_value: '',
						},
						{
							value: 'Queen',
							priority: 0,
							type: 'chip',
							type_value: '',
						},
					],
				},
				variant_data_map: [
					{
						'c065b336-6917-4897-823d-f62e430846de': 'Mint',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'King',
						product_id: '54f08aea-778b-46ff-8920-d83c996a69bc',
					},
					{
						'c065b336-6917-4897-823d-f62e430846de': 'Blue',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'Queen',
						product_id: 'ecb48371-2e2f-4b41-a86e-ad30daa074d3',
					},
				],
				hinge_attributes: [
					{
						id: 'c065b336-6917-4897-823d-f62e430846de',
						name: 'color',
						priority: 0,
					},
					{
						id: 'fdf8ff72-6f1f-4654-8714-6466cb1e8424',
						name: 'size',
						priority: 0,
					},
				],
			},
			tenant_id: '49874fec-b7a0-4745-8bc6-43409b85a6cf',
			created_at: '2023-07-26T14:56:28.011427',
			sku_id: 'CL-251-11096',
			pricing: {
				variant_price_range: {
					min_value: 600,
					max_value: 720,
				},
				unit: 'per-piece',
				id: '34cd9731-3836-4a3f-b76a-37f4d61a0491',
				pricing_rule: {
					volume: {
						name: 'Volume Discount',
						type: 'Volume',
						tiers: [],
					},
				},
				price: 720,
				product_id: '54f08aea-778b-46ff-8920-d83c996a69bc',
				price_level_id: '01d11338-4674-4643-a013-f18c5e579d98',
				currency: '$',
			},
			inventory: {
				min_order_quantity: 5,
				incremental_value: 1,
				max_order_quantity: 100,
				stock: 200,
				name: 'In Stock : 200.0 pcs',
				box_color: 'primary',
				show_stock_list: 'true',
				list: {
					in_stock: '200.0 pcs',
					on_hold: '',
					on_loom: '',
				},
			},
			category: [
				{
					name: 'Coverlet',
					children: null,
					level: 2,
					id: '9c6802cc-fbb5-449f-8449-f584932f5e42',
					parent_id: '41b81e51-f4ba-4318-9c89-bafb5f0c9e89',
					path: '41b81e51-f4ba-4318-9c89-bafb5f0c9e89,41b81e51-f4ba-4318-9c89-bafb5f0c9e89',
				},
			],
			collections: null,
		},
		{
			type: 'variant',
			parent_id: '3107a802-6f96-4c93-a74e-c10af67eb730',
			custom_attributes: [
				{
					id: 'f8da3c80-d78a-442f-bd7c-df0b25434ee3',
					name: 'other_information',
					type: 'textarea',
					value:
						'Care Instruction\\n- Machine wash cold with separately, Gentle cycle, do not bleach, Tumble - Dry low, Remove promptly, Do not iron. Dry Clean if needed',
				},
				{
					id: 'eb3b0caf-4be1-4573-933b-d681317c8cff',
					name: 'description',
					type: 'textarea',
					value:
						"Our new Dana throw collection is woven in 100% Cotton. Simplistic yet brimming with an earthy texture. It's a soft delightful layer to cozy up with no matter the season. This collection comes in relaxed neutral tones with a nomadic sensibility.",
				},
				{
					id: '4c449ea4-c805-4c8a-88fc-c35ae9dbca66',
					name: 'weight',
					type: 'text',
					value: '0.8 lbs',
				},
				{
					id: 'c4e61f4f-d1f6-4204-9a71-bd11fde99780',
					name: 'dimensions',
					type: 'text',
					value: '26.0x26.0inch',
				},
				{
					id: 'c065b336-6917-4897-823d-f62e430846de',
					name: 'color',
					type: 'select',
					value: 'Pearl',
				},
				{
					id: 'fdf8ff72-6f1f-4654-8714-6466cb1e8424',
					name: 'size',
					type: 'select',
					value: 'Euro',
				},
			],
			moq: 1,
			status: 'published',
			updated_at: '2023-07-26T16:01:00.245327',
			media: [
				{
					id: '1',
					url: 'https://orchidsluxhome.com/wp-content/uploads/2022/04/danabedthrowshampearl-1.jpg',
					type: 'image',
					is_primary: true,
				},
			],
			id: 'cc422145-da9d-4821-bc3b-c03891254e96',
			name: 'Dana Bed Throw Sham',
			variants_meta: {
				hinges_value_map: {
					'c065b336-6917-4897-823d-f62e430846de': [
						{
							value: 'Dune',
							priority: 0,
							type: 'image_label',
							type_value: 'https://orchidsluxhome.com/wp-content/uploads/2022/04/danabedthrowshamdune-1.jpg',
						},
						{
							value: 'Beige',
							priority: 0,
							type: 'image_label',
							type_value: 'https://orchidsluxhome.com/wp-content/uploads/2022/04/danabedthrowshambeige-1.jpg',
						},
						{
							value: 'Pearl',
							priority: 0,
							type: 'image_label',
							type_value: 'https://orchidsluxhome.com/wp-content/uploads/2022/04/danabedthrowshampearl-1.jpg',
						},
						{
							value: 'Navy',
							priority: 0,
							type: 'image_label',
							type_value: 'https://orchidsluxhome.com/wp-content/uploads/2022/04/danabedthrowshamnavy-1.jpg',
						},
						{
							value: 'Mint',
							priority: 0,
							type: 'image_label',
							type_value: 'https://orchidsluxhome.com/wp-content/uploads/2022/04/danabedthrowshammint-1.jpg',
						},
						{
							value: 'Lavender',
							priority: 0,
							type: 'image_label',
							type_value: 'https://orchidsluxhome.com/wp-content/uploads/2022/04/danabedthrowshamlavender-1.jpg',
						},
					],
					'fdf8ff72-6f1f-4654-8714-6466cb1e8424': [
						{
							value: 'Euro',
							priority: 0,
							type: 'chip',
							type_value: '',
						},
					],
				},
				variant_data_map: [
					{
						'c065b336-6917-4897-823d-f62e430846de': 'Dune',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'Euro',
						product_id: '3107a802-6f96-4c93-a74e-c10af67eb730',
					},
					{
						'c065b336-6917-4897-823d-f62e430846de': 'Beige',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'Euro',
						product_id: '51210db3-cc45-4816-ab5b-5f36cce9bdd6',
					},
					{
						'c065b336-6917-4897-823d-f62e430846de': 'Pearl',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'Euro',
						product_id: 'cc422145-da9d-4821-bc3b-c03891254e96',
					},
					{
						'c065b336-6917-4897-823d-f62e430846de': 'Navy',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'Euro',
						product_id: '9c09d215-2933-4dc8-8521-19e2a8ed82b6',
					},
					{
						'c065b336-6917-4897-823d-f62e430846de': 'Mint',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'Euro',
						product_id: '871c873e-3afd-4102-ac8c-e1f4f1289820',
					},
					{
						'c065b336-6917-4897-823d-f62e430846de': 'Lavender',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'Euro',
						product_id: '4863d6a1-e5d3-4bde-b165-fabc24ba1ad8',
					},
				],
				hinge_attributes: [
					{
						id: 'c065b336-6917-4897-823d-f62e430846de',
						name: 'color',
						priority: 0,
					},
					{
						id: 'fdf8ff72-6f1f-4654-8714-6466cb1e8424',
						name: 'size',
						priority: 0,
					},
				],
			},
			tenant_id: '49874fec-b7a0-4745-8bc6-43409b85a6cf',
			created_at: '2023-07-26T14:56:28.011427',
			sku_id: 'ES-103-2626',
			pricing: {
				variant_price_range: {
					min_value: 105,
					max_value: 105,
				},
				unit: 'per piece',
				id: 'da84cfe7-7c3e-495e-a1a9-f0cac634dbc5',
				pricing_rule: {
					volume: {
						name: 'Volume Discount',
						type: 'Volume',
						tiers: [],
					},
				},
				price: 105,
				product_id: 'cc422145-da9d-4821-bc3b-c03891254e96',
				price_level_id: '01d11338-4674-4643-a013-f18c5e579d98',
				currency: '$',
			},
			inventory: {
				min_order_quantity: 1,
				incremental_value: 1,
				max_order_quantity: 10000,
				stock: 11,
				name: 'In Stock : 11.0 pcs',
				box_color: 'primary',
				show_stock_list: 'true',
				list: {
					in_stock: '11.0 pcs',
					on_hold: '',
					on_loom: '',
				},
			},
			category: [
				{
					name: 'Bed Throws',
					children: null,
					level: 2,
					id: '6e39b764-c44e-4145-98b4-1a3b1cba3a8f',
					parent_id: '41b81e51-f4ba-4318-9c89-bafb5f0c9e89',
					path: '41b81e51-f4ba-4318-9c89-bafb5f0c9e89,41b81e51-f4ba-4318-9c89-bafb5f0c9e89',
				},
			],
			collections: null,
		},
		{
			type: 'variant',
			parent_id: '6d21bea5-0f8a-41c2-98be-02f02a8ac70c',
			custom_attributes: [
				{
					id: 'f8da3c80-d78a-442f-bd7c-df0b25434ee3',
					name: 'other_information',
					type: 'textarea',
					value: 'Care & Maintenance\\n- Dry clean only',
				},
				{
					id: 'eb3b0caf-4be1-4573-933b-d681317c8cff',
					name: 'description',
					type: 'textarea',
					value:
						"A sense of serenity and luxurious comfort you'll love incorporating into any bedroom in your home, add the BIOBASED LYOCELL 400-Thread Count. These 400 threads count sheet set coordinates with your existing bedscape or brings new life to a refresh with the solid Color and timeless design. The 100% lyocell construction makes way for a heavenly soft, smooth and cool feel, so you can rest comfortably night after night and wake up feeling refreshed and restoRed. This BIOBASED LYOCELL is softer than Silk, cooler than linen, more absorbent than Cotton. A clean and modern aesthetic combined with dramatic performance, it is drapey, wrinkle free, crisp, cool, soft, affordable luxury, whether you choose coordinating Pillowcases or ones in a contrasting print, you'll love the touch of luxury this BIOBASED LYOCELL sheet set adds to your bedding arrangement. This is your invitation to create a space that's just for you. Make room to relax with BIOBASED LYOCELL, where calm and comfort are Naturally at home. It's a new age fibre made in harmony with nature whose unique structure creates an optimal skin climate for the soundest of sleep. We're committed to maKing products better for you, and the world.\n\\nThis product is STANDARD 100 by OEKO-TEX¨ certified, meaning that everything from the dyes and fabrics to accessories like buttons and zippers are tested and verified as free from harmful levels of more than 300 substances. OLH 400TC LYOCELL FABRIC We make sustainable bedding from Lyocell fabric and the lyocell fabric is made out of high-quality wood pulp, a sustainable and renewable Natural resource. We do not harvest wood from ancient or endangeRed forest. Instead, our trees are grown on sustainably managed and biodiverse farms. Plus, fort every tree harvested, two more are planted.\n\\n\n\\nDetails you'll appreciate\n\\n- Our product has several certifications which are key in today market place.\n\\n- Key certification is as mentioned below;\n\\n- OEKO-TEX¨ Standard 100 - The international safety standard for all textiles\n\\n- Vegan Cruelty-Free - We don't test on animals (but we do let them sleep in our bed)\n\\n- ZDHC - Ensures there no wastewater runoff at our plant\n\\n- Canopy - NGO that oversees our forest management efforts.\n\\n- Pillow Cases sizes are STD 20\" x 32\" and King 20\" x 40\"\n\\n- Available Colors are White/Beige and White/Navy\n\\n\n\\nCare Instruction\n\\n- Machine wash cold with like Colors, Gentle cycle, do not bleach, Tumble - Dry low, Remove promptly, Warm iron as needed.",
				},
				{
					id: '4c449ea4-c805-4c8a-88fc-c35ae9dbca66',
					name: 'weight',
					type: 'text',
					value: '0.36 lbs',
				},
				{
					id: 'c4e61f4f-d1f6-4204-9a71-bd11fde99780',
					name: 'dimensions',
					type: 'text',
					value: '20.0x32.0inch',
				},
				{
					id: 'c065b336-6917-4897-823d-f62e430846de',
					name: 'color',
					type: 'select',
					value: 'Navy',
				},
				{
					id: 'fdf8ff72-6f1f-4654-8714-6466cb1e8424',
					name: 'size',
					type: 'select',
					value: 'Standard Pillow Case (Set of 2)',
				},
			],
			moq: 1,
			status: 'published',
			updated_at: '2023-07-26T16:01:00.245327',
			media: [
				{
					id: '1',
					url: 'https://orchidsluxhome.com/wp-content/uploads/2022/04/PORTO-WHITE-NAVY-PILLOW-CASE-1.jpg',
					type: 'image',
					is_primary: true,
				},
				{
					id: '2',
					url: ' https://orchidsluxhome.com/wp-content/uploads/2022/04/portopillowcasewhitenavy2-1.jpg',
					type: 'image',
					is_primary: false,
				},
			],
			id: '719bbd57-b589-4cd5-88e3-9fac45a1b13c',
			name: 'Porto Pillow Case',
			variants_meta: {
				hinges_value_map: {
					'c065b336-6917-4897-823d-f62e430846de': [
						{
							value: 'Beige',
							priority: 0,
							type: 'image_label',
							type_value: ' https://orchidsluxhome.com/wp-content/uploads/2022/04/portopillowcasewhitebeige1-1.jpg',
						},
						{
							value: 'Navy',
							priority: 0,
							type: 'image_label',
							type_value: ' https://orchidsluxhome.com/wp-content/uploads/2022/04/portopillowcasewhitenavy2-1.jpg',
						},
					],
					'fdf8ff72-6f1f-4654-8714-6466cb1e8424': [
						{
							value: 'King Pillow Case (Set of 2)',
							priority: 0,
							type: 'chip',
							type_value: '',
						},
						{
							value: 'Standard Pillow Case (Set of 2)',
							priority: 0,
							type: 'chip',
							type_value: '',
						},
					],
				},
				variant_data_map: [
					{
						'c065b336-6917-4897-823d-f62e430846de': 'Beige',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'King Pillow Case (Set of 2)',
						product_id: '6d21bea5-0f8a-41c2-98be-02f02a8ac70c',
					},
					{
						'c065b336-6917-4897-823d-f62e430846de': 'Navy',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'King Pillow Case (Set of 2)',
						product_id: '74a2d58b-3956-4a7e-ab99-a96b4ad86735',
					},
					{
						'c065b336-6917-4897-823d-f62e430846de': 'Beige',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'Standard Pillow Case (Set of 2)',
						product_id: 'fbcfe2e1-ca0b-492f-9242-87674e6dc9d4',
					},
					{
						'c065b336-6917-4897-823d-f62e430846de': 'Navy',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'Standard Pillow Case (Set of 2)',
						product_id: '719bbd57-b589-4cd5-88e3-9fac45a1b13c',
					},
				],
				hinge_attributes: [
					{
						id: 'c065b336-6917-4897-823d-f62e430846de',
						name: 'color',
						priority: 0,
					},
					{
						id: 'fdf8ff72-6f1f-4654-8714-6466cb1e8424',
						name: 'size',
						priority: 0,
					},
				],
			},
			tenant_id: '49874fec-b7a0-4745-8bc6-43409b85a6cf',
			created_at: '2023-07-26T14:56:28.011427',
			sku_id: 'ASP-513-2032',
			pricing: {
				variant_price_range: {
					min_value: 90,
					max_value: 120,
				},
				unit: 'per piece',
				id: 'fc365c42-8945-421c-8fa0-45e0db594cfa',
				pricing_rule: {
					volume: {
						name: 'Volume Discount',
						type: 'Volume',
						tiers: [],
					},
				},
				price: 90,
				product_id: '719bbd57-b589-4cd5-88e3-9fac45a1b13c',
				price_level_id: '01d11338-4674-4643-a013-f18c5e579d98',
				currency: '$',
			},
			inventory: {
				min_order_quantity: 1,
				incremental_value: 1,
				max_order_quantity: 10000,
				stock: 20,
				name: 'In Stock : 20.0 pcs',
				box_color: 'primary',
				show_stock_list: 'true',
				list: {
					in_stock: '20.0 pcs',
					on_hold: '',
					on_loom: '',
				},
			},
			category: [
				{
					name: '100% Lyocell',
					children: null,
					level: 2,
					id: '70dfffbb-2c94-491f-9438-745b6bc14237',
					parent_id: '192591b0-7fdd-465d-b111-62d7abccdf22',
					path: '192591b0-7fdd-465d-b111-62d7abccdf22,192591b0-7fdd-465d-b111-62d7abccdf22',
				},
			],
			collections: null,
		},
		{
			type: 'variant',
			parent_id: '3e6ae058-2239-4c39-a554-2e648a3adc6b',
			custom_attributes: [
				{
					id: 'f8da3c80-d78a-442f-bd7c-df0b25434ee3',
					name: 'other_information',
					type: 'textarea',
					value:
						'Care Instruction\\n- Machine wash cold with separately, Gentle cycle, do not bleach, Tumble - Dry low, Remove promptly, Do not iron. Dry Clean if needed',
				},
				{
					id: 'eb3b0caf-4be1-4573-933b-d681317c8cff',
					name: 'description',
					type: 'textarea',
					value:
						"Our new Dana throw collection is woven in 100% Cotton. Simplistic yet brimming with an earthy texture. It's a soft delightful layer to cozy up with no matter the season. This collection comes in relaxed neutral tones with a nomadic sensibility.",
				},
				{
					id: '4c449ea4-c805-4c8a-88fc-c35ae9dbca66',
					name: 'weight',
					type: 'text',
					value: '4.2 lbs',
				},
				{
					id: 'c4e61f4f-d1f6-4204-9a71-bd11fde99780',
					name: 'dimensions',
					type: 'text',
					value: '94.0x96.0inch',
				},
				{
					id: 'c065b336-6917-4897-823d-f62e430846de',
					name: 'color',
					type: 'select',
					value: 'Beige',
				},
				{
					id: 'fdf8ff72-6f1f-4654-8714-6466cb1e8424',
					name: 'size',
					type: 'select',
					value: 'Queen',
				},
			],
			moq: 1,
			status: 'published',
			updated_at: '2023-07-26T16:01:00.245327',
			media: [
				{
					id: '1',
					url: 'https://orchidsluxhome.com/wp-content/uploads/2022/04/danabedthrowsbeige1-1.jpg',
					type: 'image',
					is_primary: true,
				},
				{
					id: '2',
					url: ' https://orchidsluxhome.com/wp-content/uploads/2022/04/danabedthrowsbeige4-1.jpg',
					type: 'image',
					is_primary: false,
				},
				{
					id: '3',
					url: ' https://orchidsluxhome.com/wp-content/uploads/2022/04/danabedthrowsbeige2-1.jpg',
					type: 'image',
					is_primary: false,
				},
				{
					id: '4',
					url: ' https://orchidsluxhome.com/wp-content/uploads/2022/04/danabedthrowsbeige3-1.jpg',
					type: 'image',
					is_primary: false,
				},
			],
			id: '21fbc067-c5b0-4c0f-974b-8088254dce75',
			name: 'Dana Bed Throw',
			variants_meta: {
				hinges_value_map: {
					'c065b336-6917-4897-823d-f62e430846de': [
						{
							value: 'Dune',
							priority: 0,
							type: 'image_label',
							type_value: ' https://orchidsluxhome.com/wp-content/uploads/2022/04/danabedthrowsdune4-1.jpg',
						},
						{
							value: 'Beige',
							priority: 0,
							type: 'image_label',
							type_value: ' https://orchidsluxhome.com/wp-content/uploads/2022/04/danabedthrowsbeige4-1.jpg',
						},
						{
							value: 'Pearl',
							priority: 0,
							type: 'image_label',
							type_value: ' https://orchidsluxhome.com/wp-content/uploads/2022/04/danabedthrowspearl4-1.jpg',
						},
						{
							value: 'Navy',
							priority: 0,
							type: 'image_label',
							type_value: ' https://orchidsluxhome.com/wp-content/uploads/2022/04/danabedthrowsnavy4-1.jpg',
						},
						{
							value: 'Mint',
							priority: 0,
							type: 'image_label',
							type_value: ' https://orchidsluxhome.com/wp-content/uploads/2022/04/danabedthrowsmint5-1.jpg',
						},
						{
							value: 'Lavender',
							priority: 0,
							type: 'image_label',
							type_value: ' https://orchidsluxhome.com/wp-content/uploads/2022/04/danabedthrowslavender5-1.jpg',
						},
					],
					'fdf8ff72-6f1f-4654-8714-6466cb1e8424': [
						{
							value: 'King',
							priority: 0,
							type: 'chip',
							type_value: '',
						},
						{
							value: 'Queen',
							priority: 0,
							type: 'chip',
							type_value: '',
						},
					],
				},
				variant_data_map: [
					{
						'c065b336-6917-4897-823d-f62e430846de': 'Dune',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'King',
						product_id: '3e6ae058-2239-4c39-a554-2e648a3adc6b',
					},
					{
						'c065b336-6917-4897-823d-f62e430846de': 'Dune',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'Queen',
						product_id: '5d6b39ed-6147-434a-a362-56774acc38c1',
					},
					{
						'c065b336-6917-4897-823d-f62e430846de': 'Beige',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'King',
						product_id: '53fa8eef-31fe-4f2b-8ac3-d593e7994d48',
					},
					{
						'c065b336-6917-4897-823d-f62e430846de': 'Beige',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'Queen',
						product_id: '21fbc067-c5b0-4c0f-974b-8088254dce75',
					},
					{
						'c065b336-6917-4897-823d-f62e430846de': 'Pearl',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'King',
						product_id: '1d25b7f8-3748-42c2-84ca-b07741ef0e6d',
					},
					{
						'c065b336-6917-4897-823d-f62e430846de': 'Pearl',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'Queen',
						product_id: '3b3660d2-f8ea-4205-b586-b0487e81d2a9',
					},
					{
						'c065b336-6917-4897-823d-f62e430846de': 'Navy',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'King',
						product_id: '2232fdbd-3a4a-4966-a80f-f9765d96f474',
					},
					{
						'c065b336-6917-4897-823d-f62e430846de': 'Navy',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'Queen',
						product_id: '7477ca79-beb4-424e-b7fd-7e161c24b46b',
					},
					{
						'c065b336-6917-4897-823d-f62e430846de': 'Mint',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'King',
						product_id: '0739f0c7-9317-49e9-bfb2-192f94ae9bd9',
					},
					{
						'c065b336-6917-4897-823d-f62e430846de': 'Mint',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'Queen',
						product_id: '7548febd-666e-4c1f-b5ac-8a4ac5813333',
					},
					{
						'c065b336-6917-4897-823d-f62e430846de': 'Lavender',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'King',
						product_id: '6a235642-dadc-497a-ac1d-c58d37e9e7d4',
					},
					{
						'c065b336-6917-4897-823d-f62e430846de': 'Lavender',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'Queen',
						product_id: '111916e0-dc4a-46d2-8b74-dfc7a4406f22',
					},
				],
				hinge_attributes: [
					{
						id: 'c065b336-6917-4897-823d-f62e430846de',
						name: 'color',
						priority: 0,
					},
					{
						id: 'fdf8ff72-6f1f-4654-8714-6466cb1e8424',
						name: 'size',
						priority: 0,
					},
				],
			},
			tenant_id: '49874fec-b7a0-4745-8bc6-43409b85a6cf',
			created_at: '2023-07-26T14:56:28.011427',
			sku_id: 'BT-102-9496',
			pricing: {
				variant_price_range: {
					min_value: 270,
					max_value: 330,
				},
				unit: 'per piece',
				id: '4aa3a417-6889-4b55-9388-f512143e99fa',
				pricing_rule: {
					volume: {
						name: 'Volume Discount',
						type: 'Volume',
						tiers: [],
					},
				},
				price: 270,
				product_id: '21fbc067-c5b0-4c0f-974b-8088254dce75',
				price_level_id: '01d11338-4674-4643-a013-f18c5e579d98',
				currency: '$',
			},
			inventory: {
				min_order_quantity: 1,
				incremental_value: 1,
				max_order_quantity: 10000,
				stock: 35,
				name: 'In Stock : 35.0 pcs',
				box_color: 'primary',
				show_stock_list: 'true',
				list: {
					in_stock: '35.0 pcs',
					on_hold: '',
					on_loom: '',
				},
			},
			category: [
				{
					name: 'Bed Throws',
					children: null,
					level: 2,
					id: '6e39b764-c44e-4145-98b4-1a3b1cba3a8f',
					parent_id: '41b81e51-f4ba-4318-9c89-bafb5f0c9e89',
					path: '41b81e51-f4ba-4318-9c89-bafb5f0c9e89,41b81e51-f4ba-4318-9c89-bafb5f0c9e89',
				},
			],
			collections: [
				{
					id: '0bc50dbf-b155-4993-82ba-e47b05a218d6',
					media: [
						{
							type: 'image',
							view_type: 'thumbnail',
							url: 'https://sourcerer.tech/assets/b7a7e353-ea55-4442-901e-611f36d10c1a',
						},
					],
					name: 'Beige Enchantment',
					priority: 0,
				},
			],
		},
		{
			type: 'variant',
			parent_id: '87811cc9-8e68-4611-a107-47fc60713105',
			custom_attributes: [
				{
					id: 'f8da3c80-d78a-442f-bd7c-df0b25434ee3',
					name: 'other_information',
					type: 'textarea',
					value:
						'Care Instruction\\n- Machine wash cold with separately, Gentle cycle, do not bleach, Tumble - Dry low, Remove promptly, Do not iron. Dry Clean if needed',
				},
				{
					id: 'eb3b0caf-4be1-4573-933b-d681317c8cff',
					name: 'description',
					type: 'textarea',
					value:
						'The Doyle bed throw is a two-layer woven bed throw made from 100% Cotton, We love the unexpected pairing of coastal Colors with checks that creates a fashion-forward look reminiscent of summer on the seashore. The soft and light Cotton keeps it fresh and makes it a great addition to your living space.',
				},
				{
					id: '4c449ea4-c805-4c8a-88fc-c35ae9dbca66',
					name: 'weight',
					type: 'text',
					value: '2.43 lbs',
				},
				{
					id: 'c4e61f4f-d1f6-4204-9a71-bd11fde99780',
					name: 'dimensions',
					type: 'text',
					value: '110.0x96.0inch',
				},
				{
					id: 'c065b336-6917-4897-823d-f62e430846de',
					name: 'color',
					type: 'select',
					value: 'Dune',
				},
				{
					id: 'fdf8ff72-6f1f-4654-8714-6466cb1e8424',
					name: 'size',
					type: 'select',
					value: 'King',
				},
			],
			moq: 1,
			status: 'published',
			updated_at: '2023-07-26T16:01:00.245327',
			media: [
				{
					id: '1',
					url: 'https://orchidsluxhome.com/wp-content/uploads/2022/04/doylebedthrowsdune4-1.jpg',
					type: 'image',
					is_primary: true,
				},
				{
					id: '2',
					url: ' https://orchidsluxhome.com/wp-content/uploads/2022/04/doylebedthrowsdune6-1.jpg',
					type: 'image',
					is_primary: false,
				},
				{
					id: '3',
					url: ' https://orchidsluxhome.com/wp-content/uploads/2022/04/doylebedthrowsdune5-1.jpg',
					type: 'image',
					is_primary: false,
				},
				{
					id: '4',
					url: ' https://orchidsluxhome.com/wp-content/uploads/2022/04/doylebedthrowsdune3-1.jpg',
					type: 'image',
					is_primary: false,
				},
				{
					id: '5',
					url: ' https://orchidsluxhome.com/wp-content/uploads/2022/04/doylebedthrowsdune2-1.jpg',
					type: 'image',
					is_primary: false,
				},
			],
			id: 'fb9adcef-2fc3-4f80-8359-07dc88de0a99',
			name: 'Doyle Bed Throw',
			variants_meta: {
				hinges_value_map: {
					'c065b336-6917-4897-823d-f62e430846de': [
						{
							value: 'Charcoal',
							priority: 0,
							type: 'image_label',
							type_value: ' https://orchidsluxhome.com/wp-content/uploads/2022/04/doylebedthrowscharcoal6-1.jpg',
						},
						{
							value: 'Sky',
							priority: 0,
							type: 'image_label',
							type_value: ' https://orchidsluxhome.com/wp-content/uploads/2022/04/doylebedthrowssky6-1.jpg',
						},
						{
							value: 'Dune',
							priority: 0,
							type: 'image_label',
							type_value: ' https://orchidsluxhome.com/wp-content/uploads/2022/04/doylebedthrowsdune6-1.jpg',
						},
						{
							value: 'Mint',
							priority: 0,
							type: 'image_label',
							type_value: ' https://orchidsluxhome.com/wp-content/uploads/2022/04/doylebedthrowsmint6-1.jpg',
						},
						{
							value: 'Grey',
							priority: 0,
							type: 'image_label',
							type_value: ' https://orchidsluxhome.com/wp-content/uploads/2022/04/doylebedthrowsgrey6-1.jpg',
						},
					],
					'fdf8ff72-6f1f-4654-8714-6466cb1e8424': [
						{
							value: 'King',
							priority: 0,
							type: 'chip',
							type_value: '',
						},
						{
							value: 'Queen',
							priority: 0,
							type: 'chip',
							type_value: '',
						},
					],
				},
				variant_data_map: [
					{
						'c065b336-6917-4897-823d-f62e430846de': 'Charcoal',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'King',
						product_id: '87811cc9-8e68-4611-a107-47fc60713105',
					},
					{
						'c065b336-6917-4897-823d-f62e430846de': 'Charcoal',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'Queen',
						product_id: '74ee9811-2f89-40bc-9064-1050e829d1e9',
					},
					{
						'c065b336-6917-4897-823d-f62e430846de': 'Sky',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'King',
						product_id: '47ee02da-9543-4299-a6d8-9ca9d0b218b7',
					},
					{
						'c065b336-6917-4897-823d-f62e430846de': 'Sky',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'Queen',
						product_id: 'c56aa73d-3664-4443-a6c4-b351abf5d4e0',
					},
					{
						'c065b336-6917-4897-823d-f62e430846de': 'Dune',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'King',
						product_id: 'fb9adcef-2fc3-4f80-8359-07dc88de0a99',
					},
					{
						'c065b336-6917-4897-823d-f62e430846de': 'Dune',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'Queen',
						product_id: 'fbfe30eb-bd6b-4081-aaa9-65ace6186b4e',
					},
					{
						'c065b336-6917-4897-823d-f62e430846de': 'Mint',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'King',
						product_id: 'cbd4a392-3fa3-4033-95d7-8df3ad02eefb',
					},
					{
						'c065b336-6917-4897-823d-f62e430846de': 'Mint',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'Queen',
						product_id: '5dce7f04-9152-41c0-b888-a33be8435273',
					},
					{
						'c065b336-6917-4897-823d-f62e430846de': 'Grey',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'King',
						product_id: '718e996d-5604-4305-88c1-a5c46196bd72',
					},
					{
						'c065b336-6917-4897-823d-f62e430846de': 'Grey',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'Queen',
						product_id: 'b70b42a5-c324-4524-84a3-087f5ed18571',
					},
				],
				hinge_attributes: [
					{
						id: 'c065b336-6917-4897-823d-f62e430846de',
						name: 'color',
						priority: 0,
					},
					{
						id: 'fdf8ff72-6f1f-4654-8714-6466cb1e8424',
						name: 'size',
						priority: 0,
					},
				],
			},
			tenant_id: '49874fec-b7a0-4745-8bc6-43409b85a6cf',
			created_at: '2023-07-26T14:56:28.011427',
			sku_id: 'BT-118-11096',
			pricing: {
				variant_price_range: {
					min_value: 300,
					max_value: 360,
				},
				unit: 'per piece',
				id: '42198420-9c0b-4b11-8c12-a7fdda56acfa',
				pricing_rule: {
					volume: {
						name: 'Volume Discount',
						type: 'Volume',
						tiers: [],
					},
				},
				price: 360,
				product_id: 'fb9adcef-2fc3-4f80-8359-07dc88de0a99',
				price_level_id: '01d11338-4674-4643-a013-f18c5e579d98',
				currency: '$',
			},
			inventory: {
				min_order_quantity: 1,
				incremental_value: 1,
				max_order_quantity: 10000,
				stock: 29,
				name: 'In Stock : 29.0 pcs',
				box_color: 'primary',
				show_stock_list: 'true',
				list: {
					in_stock: '29.0 pcs',
					on_hold: '',
					on_loom: '',
				},
			},
			category: [
				{
					name: 'Bed Throws',
					children: null,
					level: 2,
					id: '6e39b764-c44e-4145-98b4-1a3b1cba3a8f',
					parent_id: '41b81e51-f4ba-4318-9c89-bafb5f0c9e89',
					path: '41b81e51-f4ba-4318-9c89-bafb5f0c9e89,41b81e51-f4ba-4318-9c89-bafb5f0c9e89',
				},
			],
			collections: null,
		},
		{
			type: 'variant',
			parent_id: '4bc549e3-132e-4518-8e7f-3cbbb4c8d74f',
			custom_attributes: [
				{
					id: 'f8da3c80-d78a-442f-bd7c-df0b25434ee3',
					name: 'other_information',
					type: 'textarea',
					value: 'Care & Maintenance\\n- Dry clean only',
				},
				{
					id: 'eb3b0caf-4be1-4573-933b-d681317c8cff',
					name: 'description',
					type: 'textarea',
					value:
						'A sense of serenity and luxurious comfort you\'ll love incorporating into any bedroom in your home, add the BIOBASED LYOCELL 400-Thread Count. These 400 threads count sheet set coordinates with your existing bedscape or brings new life to a refresh with the solid Color and timeless design. The 100% lyocell construction makes way for a heavenly soft, smooth and cool feel, so you can rest comfortably night after night and wake up feeling refreshed and restoRed. This BIOBASED LYOCELL is softer than Silk, cooler than linen, more absorbent than Cotton. A clean and modern aesthetic combined with dramatic performance, it is drapey, wrinkle free, crisp, cool, soft, affordable luxury, whether you choose coordinating Pillowcases or ones in a contrasting print, you\'ll love the touch of luxury this BIOBASED LYOCELL sheet set adds to your bedding arrangement. This is your invitation to create a space that\'s just for you. Make room to relax with BIOBASED LYOCELL, where calm and comfort are Naturally at home. It\'s a new age fibre made in harmony with nature whose unique structure creates an optimal skin climate for the soundest of sleep. We\'re committed to maKing products better for you, and the world.\n\\nThis product is STANDARD 100 by OEKO-TEX¨ certified, meaning that everything from the dyes and fabrics to accessories like buttons and zippers are tested and verified as free from harmful levels of more than 300 substances. OLH 400TC LYOCELL FABRIC We make sustainable bedding from Lyocell fabric and the lyocell fabric is made out of high-quality wood pulp, a sustainable and renewable Natural resource. We do not harvest wood from ancient or endangeRed forest. Instead, our trees are grown on sustainably managed and biodiverse farms. Plus, fort every tree harvested, two more are planted.\n\\n\n\\nDetails you\'ll appreciate\n\\n- Our product has several certifications which are key in today market place.\n\\n- Key certification is as mentioned below;\n\\n- OEKO-TEX¨ Standard 100 - The international safety standard for all textiles\n\\n- Vegan Cruelty-Free - We don\'t test on animals (but we do let them sleep in our bed)\n\\n- ZDHC - Ensures there no wastewater runoff at our plant\n\\n- Canopy - NGO that oversees our forest management efforts\n\\n- Queen (Set of 4 Pcs) Flat Sheet 100" x 107" - 1 Pc Fitted Sheet 60" x 80"+18" -1 Pc Std Pillow Cases 20" x 32" - 2 Pcs\n\\n- King (Set of 4 pcs) Flat sheet 118" x 107"- 1 Pc Fitted Sheet 78"X x 80"+17" - 1 Pc King Pillow Cases 20" x 40"- 2 Pcs\n\\n- Cal King (Set of 4 Pcs) Flat Sheet 118" x 107" - 1 Pc Fitted Sheet 72" x 84"+18"-1 PcKing Pillow Cases 20" x 40" -2 Pcs\n\\n- Available Colors are White, Beige and Navy\n\\n\n\\nCare Instruction\n\\n- Machine wash cold with like Colors, Gentle cycle, do not bleach, Tumble - Dry low, Remove promptly, Warm iron as needed.',
				},
				{
					id: '4c449ea4-c805-4c8a-88fc-c35ae9dbca66',
					name: 'weight',
					type: 'text',
					value: '1.82 lbs',
				},
				{
					id: 'c4e61f4f-d1f6-4204-9a71-bd11fde99780',
					name: 'dimensions',
					type: 'text',
					value: 'nanxnaninch',
				},
				{
					id: 'c065b336-6917-4897-823d-f62e430846de',
					name: 'color',
					type: 'select',
					value: 'Navy',
				},
				{
					id: 'fdf8ff72-6f1f-4654-8714-6466cb1e8424',
					name: 'size',
					type: 'select',
					value: 'King Sheet Set',
				},
			],
			moq: 1,
			status: 'published',
			updated_at: '2023-07-26T16:01:00.245327',
			media: [
				{
					id: '1',
					url: 'https://orchidsluxhome.com/wp-content/uploads/2022/04/MERIDA-NAVY-SHEET-SET-1-1.jpg',
					type: 'image',
					is_primary: true,
				},
				{
					id: '2',
					url: ' https://orchidsluxhome.com/wp-content/uploads/2022/04/meridasheetsetnavy5-1.jpg',
					type: 'image',
					is_primary: false,
				},
				{
					id: '3',
					url: ' https://orchidsluxhome.com/wp-content/uploads/2022/04/meridasheetsetnavy4-1.jpg',
					type: 'image',
					is_primary: false,
				},
				{
					id: '4',
					url: ' https://orchidsluxhome.com/wp-content/uploads/2022/04/meridasheetsetnavy3-1.jpg',
					type: 'image',
					is_primary: false,
				},
				{
					id: '5',
					url: ' https://orchidsluxhome.com/wp-content/uploads/2022/04/meridasheetsetnavy1-1.jpg',
					type: 'image',
					is_primary: false,
				},
			],
			id: '078bd554-b97d-44d2-9146-80745cdcc82a',
			name: 'Merida Sheet Set',
			variants_meta: {
				hinges_value_map: {
					'c065b336-6917-4897-823d-f62e430846de': [
						{
							value: 'White',
							priority: 0,
							type: 'image_label',
							type_value: ' https://orchidsluxhome.com/wp-content/uploads/2022/04/meridasheetsetwhite5-1.jpg',
						},
						{
							value: 'Beige',
							priority: 0,
							type: 'image_label',
							type_value: ' https://orchidsluxhome.com/wp-content/uploads/2022/04/meridasheetsetbeige5-1.jpg',
						},
						{
							value: 'Navy',
							priority: 0,
							type: 'image_label',
							type_value: ' https://orchidsluxhome.com/wp-content/uploads/2022/04/meridasheetsetnavy5-1.jpg',
						},
					],
					'fdf8ff72-6f1f-4654-8714-6466cb1e8424': [
						{
							value: 'Cal King Sheet Set',
							priority: 0,
							type: 'chip',
							type_value: '',
						},
						{
							value: 'King Sheet Set',
							priority: 0,
							type: 'chip',
							type_value: '',
						},
						{
							value: 'Queen Sheet Set',
							priority: 0,
							type: 'chip',
							type_value: '',
						},
					],
				},
				variant_data_map: [
					{
						'c065b336-6917-4897-823d-f62e430846de': 'White',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'Cal King Sheet Set',
						product_id: '4bc549e3-132e-4518-8e7f-3cbbb4c8d74f',
					},
					{
						'c065b336-6917-4897-823d-f62e430846de': 'Beige',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'Cal King Sheet Set',
						product_id: '2a259646-da78-4763-a650-1c0840a8fe2a',
					},
					{
						'c065b336-6917-4897-823d-f62e430846de': 'Navy',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'Cal King Sheet Set',
						product_id: '4694c2de-025f-4288-b3d1-887d1f7bd9d1',
					},
					{
						'c065b336-6917-4897-823d-f62e430846de': 'White',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'King Sheet Set',
						product_id: '0d8f58e1-b109-425a-9f7f-7cf50087a206',
					},
					{
						'c065b336-6917-4897-823d-f62e430846de': 'Beige',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'King Sheet Set',
						product_id: 'f9a0a76b-a102-410b-ba99-6aeefdfadfca',
					},
					{
						'c065b336-6917-4897-823d-f62e430846de': 'Navy',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'King Sheet Set',
						product_id: '078bd554-b97d-44d2-9146-80745cdcc82a',
					},
					{
						'c065b336-6917-4897-823d-f62e430846de': 'White',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'Queen Sheet Set',
						product_id: 'd43e2e7b-db1d-4b6d-b568-09421014e727',
					},
					{
						'c065b336-6917-4897-823d-f62e430846de': 'Beige',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'Queen Sheet Set',
						product_id: 'b86549b5-249b-467c-81db-021a024b21db',
					},
					{
						'c065b336-6917-4897-823d-f62e430846de': 'Navy',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'Queen Sheet Set',
						product_id: '06aac684-76ab-43aa-b9ea-bc50ee7a0708',
					},
				],
				hinge_attributes: [
					{
						id: 'c065b336-6917-4897-823d-f62e430846de',
						name: 'color',
						priority: 0,
					},
					{
						id: 'fdf8ff72-6f1f-4654-8714-6466cb1e8424',
						name: 'size',
						priority: 0,
					},
				],
			},
			tenant_id: '49874fec-b7a0-4745-8bc6-43409b85a6cf',
			created_at: '2023-07-26T14:56:28.011427',
			sku_id: 'KSS-511-7880',
			pricing: {
				variant_price_range: {
					min_value: 360,
					max_value: 435,
				},
				unit: 'per piece',
				id: 'df6c7ce3-3e8d-427e-b281-d9685edd96fb',
				pricing_rule: {
					volume: {
						name: 'Volume Discount',
						type: 'Volume',
						tiers: [],
					},
				},
				price: 405,
				product_id: '078bd554-b97d-44d2-9146-80745cdcc82a',
				price_level_id: '01d11338-4674-4643-a013-f18c5e579d98',
				currency: '$',
			},
			inventory: {
				min_order_quantity: 1,
				incremental_value: 1,
				max_order_quantity: 10000,
				stock: 35,
				name: 'In Stock : 35.0 pcs',
				box_color: 'primary',
				show_stock_list: 'true',
				list: {
					in_stock: '35.0 pcs',
					on_hold: '',
					on_loom: '',
				},
			},
			category: [
				{
					name: '100% Lyocell',
					children: null,
					level: 2,
					id: '70dfffbb-2c94-491f-9438-745b6bc14237',
					parent_id: '192591b0-7fdd-465d-b111-62d7abccdf22',
					path: '192591b0-7fdd-465d-b111-62d7abccdf22,192591b0-7fdd-465d-b111-62d7abccdf22',
				},
			],
			collections: null,
		},
		{
			type: 'variant',
			parent_id: 'f35e60e1-2aa0-4561-8a75-b33b50fa82f7',
			custom_attributes: [
				{
					id: 'f8da3c80-d78a-442f-bd7c-df0b25434ee3',
					name: 'other_information',
					type: 'textarea',
					value:
						'WASHING: Wash separately in cold water on a short, gentle cycle, with as much water as possible to allow for movement.\nDRYING: Careful drying is really important. Tumble dry on a delicate setting, low heat. ',
				},
				{
					id: 'eb3b0caf-4be1-4573-933b-d681317c8cff',
					name: 'description',
					type: 'textarea',
					value:
						'Soon to become your favorite year-round staple. Our blankets is designed with cuddling in mind and all-Cotton construction gives it a comfy and light feel. Expertly crafted for everyday use, the blanket has an ideal weight that works in every climate. Our Cotton textural woven blanket has a solid border which gives a nice tailoRed look for those who sleep warm year round regardless of climate.nnAvailable in White & Ivory to perfectly match your style.',
				},
				{
					id: '4c449ea4-c805-4c8a-88fc-c35ae9dbca66',
					name: 'weight',
					type: 'text',
					value: '1.5 lbs',
				},
				{
					id: 'c4e61f4f-d1f6-4204-9a71-bd11fde99780',
					name: 'dimensions',
					type: 'text',
					value: '110X96 Inch',
				},
				{
					id: 'c065b336-6917-4897-823d-f62e430846de',
					name: 'color',
					type: 'select',
					value: 'Off-white',
				},
				{
					id: 'fdf8ff72-6f1f-4654-8714-6466cb1e8424',
					name: 'size',
					type: 'select',
					value: 'Queen',
				},
			],
			moq: 5,
			status: 'published',
			updated_at: '2023-07-26T16:01:00.245327',
			media: [
				{
					id: '1',
					url: 'https://sourcerer.tech/assets/2c461492-05cc-4110-b966-6473fe3e905d',
					type: 'image',
					is_primary: true,
				},
				{
					id: '2',
					url: 'https://orchidsluxhome.com/wp-content/uploads/2022/05/RIVIERA-BLANKET-WHITE-3.jpg',
					type: 'image',
					is_primary: false,
				},
				{
					id: '3',
					url: 'https://orchidsluxhome.com/wp-content/uploads/2022/05/RIVIERA-BLANKET-WHITE-2.jpg',
					type: 'image',
					is_primary: false,
				},
			],
			id: '61269091-2eff-4982-bdc6-cb05abf05177',
			name: 'Riviera Blanket',
			variants_meta: {
				hinges_value_map: {
					'c065b336-6917-4897-823d-f62e430846de': [
						{
							value: 'White',
							priority: 0,
							type: 'image_label',
							type_value: 'https://sourcerer.tech/assets/2c461492-05cc-4110-b966-6473fe3e905d',
						},
						{
							value: 'Off-white',
							priority: 0,
							type: 'image_label',
							type_value: 'https://sourcerer.tech/assets/2c461492-05cc-4110-b966-6473fe3e905d',
						},
					],
					'fdf8ff72-6f1f-4654-8714-6466cb1e8424': [
						{
							value: 'King',
							priority: 0,
							type: 'chip',
							type_value: '',
						},
						{
							value: 'Queen',
							priority: 0,
							type: 'chip',
							type_value: '',
						},
					],
				},
				variant_data_map: [
					{
						'c065b336-6917-4897-823d-f62e430846de': 'White',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'King',
						product_id: 'f35e60e1-2aa0-4561-8a75-b33b50fa82f7',
					},
					{
						'c065b336-6917-4897-823d-f62e430846de': 'Off-white',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'King',
						product_id: '815dd2b7-7747-42f0-8430-2e0e87340ba5',
					},
					{
						'c065b336-6917-4897-823d-f62e430846de': 'White',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'Queen',
						product_id: 'e1ed5e5d-e187-49a2-b6f8-86f25d199141',
					},
					{
						'c065b336-6917-4897-823d-f62e430846de': 'Off-white',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'Queen',
						product_id: '61269091-2eff-4982-bdc6-cb05abf05177',
					},
				],
				hinge_attributes: [
					{
						id: 'c065b336-6917-4897-823d-f62e430846de',
						name: 'color',
						priority: 0,
					},
					{
						id: 'fdf8ff72-6f1f-4654-8714-6466cb1e8424',
						name: 'size',
						priority: 0,
					},
				],
			},
			tenant_id: '49874fec-b7a0-4745-8bc6-43409b85a6cf',
			created_at: '2023-07-26T14:56:28.011427',
			sku_id: 'BL-853-11099',
			pricing: {
				variant_price_range: {
					min_value: 330,
					max_value: 330,
				},
				unit: 'per piece',
				id: '9d8df074-ebd1-44a6-8ba9-929df3adefe9',
				pricing_rule: {
					volume: {
						name: 'Volume Discount',
						type: 'Volume',
						tiers: [],
					},
				},
				price: 330,
				product_id: '61269091-2eff-4982-bdc6-cb05abf05177',
				price_level_id: '01d11338-4674-4643-a013-f18c5e579d98',
				currency: '$',
			},
			inventory: {
				min_order_quantity: 5,
				incremental_value: 1,
				max_order_quantity: 100,
				stock: 50,
				name: 'In Stock : 50.0 pcs',
				box_color: 'primary',
				show_stock_list: 'true',
				list: {
					in_stock: '50.0 pcs',
					on_hold: '',
					on_loom: '',
				},
			},
			category: [
				{
					name: 'Blanket',
					children: null,
					level: 2,
					id: 'ce0626d0-8ae4-4a17-bdcc-e55e1373efea',
					parent_id: '41b81e51-f4ba-4318-9c89-bafb5f0c9e89',
					path: '41b81e51-f4ba-4318-9c89-bafb5f0c9e89,41b81e51-f4ba-4318-9c89-bafb5f0c9e89',
				},
			],
			collections: null,
		},
		{
			type: 'variant',
			parent_id: '55a8db3c-7b5b-46a0-9f80-2e34aa6ef48d',
			custom_attributes: [
				{
					id: 'f8da3c80-d78a-442f-bd7c-df0b25434ee3',
					name: 'other_information',
					type: 'textarea',
					value:
						'Care Instruction\\n- Machine wash cold with like Colors, Gentle cycle, do not bleach, Tumble - Dry low, Remove promptly, Warm iron as needed. Dry Clean if needed',
				},
				{
					id: 'eb3b0caf-4be1-4573-933b-d681317c8cff',
					name: 'description',
					type: 'textarea',
					value:
						'Delicate frays and frills composed with the elegance and beauty of pure belgian linen. A classic and timeless bed skirt collection that you and your loved ones will look forward to donning on your bed, no matter the season.',
				},
				{
					id: '4c449ea4-c805-4c8a-88fc-c35ae9dbca66',
					name: 'weight',
					type: 'text',
					value: '0.29 lbs',
				},
				{
					id: 'c4e61f4f-d1f6-4204-9a71-bd11fde99780',
					name: 'dimensions',
					type: 'text',
					value: '60.0x21.0inch',
				},
				{
					id: 'c065b336-6917-4897-823d-f62e430846de',
					name: 'color',
					type: 'select',
					value: 'White',
				},
				{
					id: 'fdf8ff72-6f1f-4654-8714-6466cb1e8424',
					name: 'size',
					type: 'select',
					value: 'Queen',
				},
			],
			moq: 1,
			status: 'published',
			updated_at: '2023-07-26T15:45:51.579874',
			media: [
				{
					id: '1',
					url: 'https://orchidsluxhome.com/wp-content/uploads/2022/04/rufflebedskirtwhite2-1.jpg',
					type: 'image',
					is_primary: true,
				},
			],
			id: '0b2e4a6a-fcbc-4aa7-8204-c66a7db90178',
			name: 'Ruffle Bed Skirt',
			variants_meta: {
				hinges_value_map: {
					'c065b336-6917-4897-823d-f62e430846de': [
						{
							value: 'White',
							priority: 0,
							type: 'image_label',
							type_value: 'https://orchidsluxhome.com/wp-content/uploads/2022/04/rufflebedskirtwhite2-1.jpg',
						},
						{
							value: 'Beige',
							priority: 0,
							type: 'image_label',
							type_value: 'https://orchidsluxhome.com/wp-content/uploads/2022/04/rufflebedskirtbeige2-1.jpg',
						},
					],
					'fdf8ff72-6f1f-4654-8714-6466cb1e8424': [
						{
							value: 'Queen',
							priority: 0,
							type: 'chip',
							type_value: '',
						},
						{
							value: 'King',
							priority: 0,
							type: 'chip',
							type_value: '',
						},
					],
				},
				variant_data_map: [
					{
						'c065b336-6917-4897-823d-f62e430846de': 'White',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'Queen',
						product_id: '0b2e4a6a-fcbc-4aa7-8204-c66a7db90178',
					},
					{
						'c065b336-6917-4897-823d-f62e430846de': 'White',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'King',
						product_id: '4d4b9194-95be-4efc-ab25-b4177920d7a1',
					},
					{
						'c065b336-6917-4897-823d-f62e430846de': 'Beige',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'Queen',
						product_id: 'a4a40b3c-e9ff-46a4-a3f1-ceb2aa924519',
					},
					{
						'c065b336-6917-4897-823d-f62e430846de': 'Beige',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'King',
						product_id: 'e77a8a25-030f-4798-901d-e4702fe630f8',
					},
				],
				hinge_attributes: [
					{
						id: 'c065b336-6917-4897-823d-f62e430846de',
						name: 'color',
						priority: 0,
					},
					{
						id: 'fdf8ff72-6f1f-4654-8714-6466cb1e8424',
						name: 'size',
						priority: 0,
					},
				],
			},
			tenant_id: '49874fec-b7a0-4745-8bc6-43409b85a6cf',
			created_at: '2023-07-26T14:56:28.011427',
			sku_id: 'BS-103-6080',
			pricing: {
				variant_price_range: {
					min_value: 330,
					max_value: 390,
				},
				unit: 'per piece',
				id: '1f8693f4-c359-462a-9c50-8a7910f8ce8b',
				pricing_rule: {
					volume: {
						name: 'Volume Discount',
						type: 'Volume',
						tiers: [],
					},
				},
				price: 330,
				product_id: '0b2e4a6a-fcbc-4aa7-8204-c66a7db90178',
				price_level_id: '01d11338-4674-4643-a013-f18c5e579d98',
				currency: '$',
			},
			inventory: {
				min_order_quantity: 1,
				incremental_value: 1,
				max_order_quantity: 10000,
				stock: 7,
				name: 'In Stock : 7.0 pcs',
				box_color: 'primary',
				show_stock_list: 'true',
				list: {
					in_stock: '7.0 pcs',
					on_hold: '',
					on_loom: '',
				},
			},
			category: [
				{
					name: 'Panel Bed Skirt',
					children: null,
					level: 2,
					id: '6715a553-f20c-448b-a43b-a1c3a48fb597',
					parent_id: '41b81e51-f4ba-4318-9c89-bafb5f0c9e89',
					path: '41b81e51-f4ba-4318-9c89-bafb5f0c9e89,41b81e51-f4ba-4318-9c89-bafb5f0c9e89',
				},
			],
			collections: null,
		},
		{
			type: 'variant',
			parent_id: 'dccdb880-4a6f-44c1-b4bc-7b24fad9274f',
			custom_attributes: [
				{
					id: 'f8da3c80-d78a-442f-bd7c-df0b25434ee3',
					name: 'other_information',
					type: 'textarea',
					value:
						'WASHING: Wash separately in cold water on a short, gentle cycle, with as much water as possible to allow for movement.\nDRYING: Careful drying is really important. Tumble dry on a delicate setting, low heat. ',
				},
				{
					id: 'eb3b0caf-4be1-4573-933b-d681317c8cff',
					name: 'description',
					type: 'textarea',
					value:
						'A new interpretation of paisley, our fluid and stylized print adds a hint of a pattern and an extra dimension of luxury to vintage-washed Belgian linen. Prewashing relaxes the linen to heirloom softness, and the distinctive motif has a weatheRed quality that echoes the historic origins of paisley art. The pieces layer beautifully with our quilt collection.',
				},
				{
					id: '4c449ea4-c805-4c8a-88fc-c35ae9dbca66',
					name: 'weight',
					type: 'text',
					value: '1.3 lbs',
				},
				{
					id: 'c4e61f4f-d1f6-4204-9a71-bd11fde99780',
					name: 'dimensions',
					type: 'text',
					value: '20X26 inch',
				},
				{
					id: 'c065b336-6917-4897-823d-f62e430846de',
					name: 'color',
					type: 'select',
					value: 'Beige',
				},
				{
					id: 'fdf8ff72-6f1f-4654-8714-6466cb1e8424',
					name: 'size',
					type: 'select',
					value: 'Standard',
				},
			],
			moq: 5,
			status: 'published',
			updated_at: '2023-07-26T15:45:51.579874',
			media: [
				{
					id: '1',
					url: 'https://sourcerer.tech/assets/a3367898-b387-4c0b-9f13-2b89f04c4f53',
					type: 'image',
					is_primary: true,
				},
			],
			id: '9103cb10-52eb-412e-9539-502a89602743',
			name: 'Abbey Duvet Cover Sham',
			variants_meta: {
				hinges_value_map: {
					'c065b336-6917-4897-823d-f62e430846de': [
						{
							value: 'Beige',
							priority: 0,
							type: 'image_label',
							type_value: 'https://sourcerer.tech/assets/a3367898-b387-4c0b-9f13-2b89f04c4f53',
						},
					],
					'fdf8ff72-6f1f-4654-8714-6466cb1e8424': [
						{
							value: 'Standard',
							priority: 0,
							type: 'chip',
							type_value: '',
						},
					],
				},
				variant_data_map: [
					{
						'c065b336-6917-4897-823d-f62e430846de': 'Beige',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'Standard',
						product_id: '9103cb10-52eb-412e-9539-502a89602743',
					},
				],
				hinge_attributes: [
					{
						id: 'c065b336-6917-4897-823d-f62e430846de',
						name: 'color',
						priority: 0,
					},
					{
						id: 'fdf8ff72-6f1f-4654-8714-6466cb1e8424',
						name: 'size',
						priority: 0,
					},
				],
			},
			tenant_id: '49874fec-b7a0-4745-8bc6-43409b85a6cf',
			created_at: '2023-07-26T14:56:28.011427',
			sku_id: 'SS-012-2026',
			pricing: {
				variant_price_range: {
					min_value: 255,
					max_value: 255,
				},
				unit: 'per piece',
				id: '3852f8bf-21d5-414f-a865-2411c8803223',
				pricing_rule: {
					volume: {
						name: 'Volume Discount',
						type: 'Volume',
						tiers: [],
					},
				},
				price: 255,
				product_id: '9103cb10-52eb-412e-9539-502a89602743',
				price_level_id: '01d11338-4674-4643-a013-f18c5e579d98',
				currency: '$',
			},
			inventory: {
				min_order_quantity: 5,
				incremental_value: 1,
				max_order_quantity: 100,
				stock: 200,
				name: 'In Stock : 200.0 pcs',
				box_color: 'primary',
				show_stock_list: 'true',
				list: {
					in_stock: '200.0 pcs',
					on_hold: '',
					on_loom: '',
				},
			},
			category: [
				{
					name: 'Duvet Cover',
					children: null,
					level: 2,
					id: 'e7729e7f-39c8-4daa-8ba2-380cc4308238',
					parent_id: '41b81e51-f4ba-4318-9c89-bafb5f0c9e89',
					path: '41b81e51-f4ba-4318-9c89-bafb5f0c9e89,41b81e51-f4ba-4318-9c89-bafb5f0c9e89',
				},
			],
			collections: [
				{
					id: '0bc50dbf-b155-4993-82ba-e47b05a218d6',
					media: [
						{
							type: 'image',
							view_type: 'thumbnail',
							url: 'https://sourcerer.tech/assets/b7a7e353-ea55-4442-901e-611f36d10c1a',
						},
					],
					name: 'Beige Enchantment',
					priority: 0,
				},
			],
		},
		{
			type: 'variant',
			parent_id: '46dc9cd1-d89d-43a6-8a6e-570426f81612',
			custom_attributes: [
				{
					id: 'f8da3c80-d78a-442f-bd7c-df0b25434ee3',
					name: 'other_information',
					type: 'textarea',
					value:
						'Care Instruction\\n- Machine wash cold with like Colors, Gentle cycle, do not bleach, Tumble - Dry low, Remove promptly, Warm iron as needed.',
				},
				{
					id: 'eb3b0caf-4be1-4573-933b-d681317c8cff',
					name: 'description',
					type: 'textarea',
					value:
						"Transporting us to the Spanish countryside and its understated and elegant beauty, the Seville sheets are made from pure linen, woven from the world's finest European flax linen, our linen bedding is pre-washed for incRedible softness and only gets better with time. Lightly textuRed and cool to the touch, this Natural-fiber fabric is prized for its durability, breathability and lived-in look. The bed linen is a genuine delight to rest and rejuvenate in. Meticulously crafted to celebrate contemporary style.",
				},
				{
					id: '4c449ea4-c805-4c8a-88fc-c35ae9dbca66',
					name: 'weight',
					type: 'text',
					value: '3.64 lbs',
				},
				{
					id: 'c4e61f4f-d1f6-4204-9a71-bd11fde99780',
					name: 'dimensions',
					type: 'text',
					value: 'nanxnaninch',
				},
				{
					id: 'c065b336-6917-4897-823d-f62e430846de',
					name: 'color',
					type: 'select',
					value: 'Mist',
				},
				{
					id: 'fdf8ff72-6f1f-4654-8714-6466cb1e8424',
					name: 'size',
					type: 'select',
					value: 'King Sheet Set',
				},
			],
			moq: 1,
			status: 'published',
			updated_at: '2023-07-26T16:01:00.245327',
			media: [
				{
					id: '1',
					url: 'https://orchidsluxhome.com/wp-content/uploads/2022/04/kyotosheetsetwhitemist3-1.jpg',
					type: 'image',
					is_primary: true,
				},
				{
					id: '2',
					url: ' https://orchidsluxhome.com/wp-content/uploads/2022/04/kyotosheetsetwhitemist6-1.jpg',
					type: 'image',
					is_primary: false,
				},
				{
					id: '3',
					url: ' https://orchidsluxhome.com/wp-content/uploads/2022/04/kyotosheetsetwhitemist5-1.jpg',
					type: 'image',
					is_primary: false,
				},
				{
					id: '4',
					url: ' https://orchidsluxhome.com/wp-content/uploads/2022/04/kyotosheetsetwhitemist4-1.jpg',
					type: 'image',
					is_primary: false,
				},
				{
					id: '5',
					url: ' https://orchidsluxhome.com/wp-content/uploads/2022/04/kyotosheetsetwhitemist2-1.jpg',
					type: 'image',
					is_primary: false,
				},
				{
					id: '6',
					url: ' https://orchidsluxhome.com/wp-content/uploads/2022/04/kyotosheetsetwhitemist1-1.jpg',
					type: 'image',
					is_primary: false,
				},
			],
			id: 'a606111a-9532-4905-8580-fa4303c19960',
			name: 'Kyoto Sheet Set',
			variants_meta: {
				hinges_value_map: {
					'c065b336-6917-4897-823d-f62e430846de': [
						{
							value: 'Beige',
							priority: 0,
							type: 'image_label',
							type_value: ' https://orchidsluxhome.com/wp-content/uploads/2022/04/kyotosheetsetwhitebeige6-1.jpg',
						},
						{
							value: 'Mist',
							priority: 0,
							type: 'image_label',
							type_value: ' https://orchidsluxhome.com/wp-content/uploads/2022/04/kyotosheetsetwhitemist6-1.jpg',
						},
					],
					'fdf8ff72-6f1f-4654-8714-6466cb1e8424': [
						{
							value: 'Cal King Sheet Set',
							priority: 0,
							type: 'chip',
							type_value: '',
						},
						{
							value: 'King Sheet Set',
							priority: 0,
							type: 'chip',
							type_value: '',
						},
						{
							value: 'Queen Sheet Set',
							priority: 0,
							type: 'chip',
							type_value: '',
						},
					],
				},
				variant_data_map: [
					{
						'c065b336-6917-4897-823d-f62e430846de': 'Beige',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'Cal King Sheet Set',
						product_id: '46dc9cd1-d89d-43a6-8a6e-570426f81612',
					},
					{
						'c065b336-6917-4897-823d-f62e430846de': 'Mist',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'Cal King Sheet Set',
						product_id: '54d88f1c-8d1d-458f-b26f-d1852bb8aa9f',
					},
					{
						'c065b336-6917-4897-823d-f62e430846de': 'Beige',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'King Sheet Set',
						product_id: 'dd8997b0-2958-45c5-93ca-d1d546d86cd7',
					},
					{
						'c065b336-6917-4897-823d-f62e430846de': 'Mist',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'King Sheet Set',
						product_id: 'a606111a-9532-4905-8580-fa4303c19960',
					},
					{
						'c065b336-6917-4897-823d-f62e430846de': 'Beige',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'Queen Sheet Set',
						product_id: '4ebdd8e6-ab20-4b9d-9e07-1ba79517aaa5',
					},
					{
						'c065b336-6917-4897-823d-f62e430846de': 'Mist',
						'fdf8ff72-6f1f-4654-8714-6466cb1e8424': 'Queen Sheet Set',
						product_id: 'dd50725b-36c6-4dce-b027-eaca66139a08',
					},
				],
				hinge_attributes: [
					{
						id: 'c065b336-6917-4897-823d-f62e430846de',
						name: 'color',
						priority: 0,
					},
					{
						id: 'fdf8ff72-6f1f-4654-8714-6466cb1e8424',
						name: 'size',
						priority: 0,
					},
				],
			},
			tenant_id: '49874fec-b7a0-4745-8bc6-43409b85a6cf',
			created_at: '2023-07-26T14:56:28.011427',
			sku_id: 'KSS-518-7880',
			pricing: {
				variant_price_range: {
					min_value: 840,
					max_value: 1020,
				},
				unit: 'per piece',
				id: '891f6120-f794-4521-afad-c99f827b51e1',
				pricing_rule: {
					volume: {
						name: 'Volume Discount',
						type: 'Volume',
						tiers: [],
					},
				},
				price: 960,
				product_id: 'a606111a-9532-4905-8580-fa4303c19960',
				price_level_id: '01d11338-4674-4643-a013-f18c5e579d98',
				currency: '$',
			},
			inventory: {
				min_order_quantity: 1,
				incremental_value: 1,
				max_order_quantity: 10000,
				stock: 5,
				name: 'In Stock : 5.0 pcs',
				box_color: 'primary',
				show_stock_list: 'true',
				list: {
					in_stock: '5.0 pcs',
					on_hold: '',
					on_loom: '',
				},
			},
			category: [
				{
					name: '100% Linen',
					children: null,
					level: 2,
					id: 'eaa14356-48c4-44fb-be79-13452828f3f4',
					parent_id: '192591b0-7fdd-465d-b111-62d7abccdf22',
					path: '192591b0-7fdd-465d-b111-62d7abccdf22,192591b0-7fdd-465d-b111-62d7abccdf22',
				},
			],
			collections: null,
		},
	],
	paginator: {},
};
